import axios from "axios";
import { getVisitorFaceData } from "../.././../utils/getVisitorFaceData";

import BASE_URL from "./../../../constants/baseURL";

export default async function signIn({
  authToken,
  agentName,
  eventID,
  ID,
  newAuthToken = false,
}) {
  sessionStorage.setItem("authToken", authToken);
  localStorage.setItem("authToken", authToken);

  const location = window.location.pathname;

  const checkInRoute = [
    "/sign-up",
    "/sign-in",
    "/manual-entry",
    "/resend-notification",
    "/manual-verification",
    "/main-gate-entry-back",
    "/main-gate-entry-front",
    "/add-booking",
    "/error-500",
  ].filter((item) => location == item);

  const axiosInstance = axios.create({
    baseURL: BASE_URL.mox_api.url + BASE_URL.mox_api.version,
    headers: {
      Authorization:
        "Bearer " + authToken || sessionStorage.getItem("authToken"),
      "Content-Type": "application/json",
    },
  });

  let visitorData;
  let dependentList;

  if (
    window.location.pathname == "/face-verification" ||
    window.location.pathname == "/liveness"
  ) {
    // await axiosInstance({
    //   url: `event/visitor/visitor-journey-started`,
    //   method: "POST",
    // });
  }

  if (!Boolean(checkInRoute.length) || newAuthToken) {
    try {
      dependentList = await axiosInstance({
        url: `event/visitor/dependent`,
        method: "GET",
      }).then((res) => res.data.data);
    } catch (error) {
      if (error.status == 401) {
        let autoRefresh = error.response.data.detail.auto_refresh;
        let refreshToken = error.response.data.detail.refresh_token;
        if (!autoRefresh) {
          localStorage.removeItem("authToken");
          sessionStorage.removeItem("authToken");
          window.location.href = "/login";
        } else {
          localStorage.removeItem("authToken");
          sessionStorage.removeItem("authToken");
          sessionStorage.setItem("authToken", refreshToken);
          localStorage.setItem("authToken", refreshToken);
          window.location.reload();
        }
      } else if (error.status == 404) {
        window.location.href = "/error-500";
      }
    }

    // ${
    //       sessionStorage.getItem("visitorID")
    //         ? "?visitor_id=" + sessionStorage.getItem("visitorID")
    //         : ""
    //     }

    try {
      visitorData = await axiosInstance({
        url: `admin/profile/get-visitor-detail${
          ID || sessionStorage.getItem("visitorId")
            ? "?visitor_id=" + (ID || sessionStorage.getItem("visitorId"))
            : ""
        }`,
        method: "POST",
        data: {
          encrypted_face_data: getVisitorFaceData(
            ID || sessionStorage.getItem("visitorId")
          ),
        },
      }).then((res) => res.data.data);
    } catch (error) {
      console.log("error", error);
      if (error.status == 401) {
        let autoRefresh = error.response.data.detail.auto_refresh;
        let refreshToken = error.response.data.detail.refresh_token;
        if (!autoRefresh) {
          localStorage.removeItem("authToken");
          sessionStorage.removeItem("authToken");
          window.location.href = "/login";
        } else {
          localStorage.removeItem("authToken");
          sessionStorage.removeItem("authToken");
          sessionStorage.setItem("authToken", refreshToken);
          localStorage.setItem("authToken", refreshToken);
          window.location.reload();
        }
      }
    }

    localStorage.setItem("visitorDataID", visitorData?._id);
  }

  return {
    authToken: authToken,
    displayName: agentName,
    eventID: eventID,
    visitorData: {
      ID: visitorData?._id,
      firstName: visitorData?.first_name,
      lastName: visitorData?.last_name,
      gender: visitorData?.gender,
      emailID: visitorData?.email_id || visitorData?.email,
      faceData: visitorData?.face_data,
      onWhatsapp: visitorData?.on_whatsapp,
      phoneNumber: visitorData?.phone_number,
      dependentList: dependentList,
      isDocVerified: visitorData?.is_doc_verified,
      userTypeIds: visitorData?.user_type_ids,
      isPrimary: visitorData?.is_primary,
    },
    businessData: {
      name: "",
      logo: "https://dolphinchat-chat.s3.ap-south-1.amazonaws.com/mpsedc/digipass/events1761823450063_1761823451822_images.png",
      color: "",
      image: "",
      fontFamily: "",
    },
  };
}
